/**
 * The sub-banner slot height ([data-sub-banner]: PremiumBanner, VerifyEmailBanner) reserved BEFORE FIRST PAINT.
 *
 * 🚨 WHY (register signed-in-visitors-still-shift-sitewide-1103). The slot is position:fixed under the header, so
 * <main> clears it with a margin. That margin came from React state measured after hydration, and the bars
 * themselves were fetched after mount: a signed-in visitor with a bar got the whole page pushed down 112px on every
 * load, measured on prod at CLS 0.1152 on a 390px phone and 0.052 at 1440 (control, no bar: 0.0000).
 *
 * ⭐ The root layout now renders the bars in the server HTML, and this inline script, placed right AFTER the slot,
 * measures it while the document is still parsing and sets --sub-banner-h on <html>. An inline parser script runs
 * after the stylesheets before it have loaded, so the measured height is the styled one. <main> takes the var in
 * its margin (ConditionalMain), and the ResizeObserver in bannerHeightWatcher keeps it current after that (a
 * dismiss writes 0, which follows a tap and is not a layout shift).
 *
 * ⛔ No 'use client' here: the root layout (a server component) imports it (see railsPrePaint.ts).
 */

export const SUB_BANNER_VAR = '--sub-banner-h'

export function subBannerPrePaintScript(): string {
  return `(function(){try{var s=document.querySelector('[data-sub-banner]');`
    + `document.documentElement.style.setProperty('${SUB_BANNER_VAR}',(s?s.getBoundingClientRect().height:0)+'px')}catch(x){}})()`
}
